const companyReducer = (state, action) => {
    const {data} = action.payload || {}

    switch (action.type) {
        case "set-company":
            return {...state, ...data};
        case "deactivate-company":
            return {};
        default:
            return state;
    }
}

export default companyReducer;
